import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

import AdminDashboardHome from "./sections/AdminDashboardHome";
import Users from "./sections/Users";
import AdminAdmissions from "./sections/Admissions/AdminAdmissions";
import AdminScholarships from "./sections/Scholarships/AdminScholarships";
import Magazines from "./sections/Magazines";
import Notices from "./sections/Notices/AdminNotices";
import Gallery from "./sections/Gallery/AdminGallery";
import AdminPollsSection from "./sections/Polls/AdminPollsSection";

const AdminDashboard = () => {
  const [activeSection, setActiveSection] = useState("Dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const renderSection = () => {
    switch (activeSection) {
      case "Users":
        return <Users />;

      case "Admissions":
        return <AdminAdmissions />;

      case "Scholarships":
        return <AdminScholarships />;

      case "Magazines":
        return <Magazines />;

      case "Notices":
        return <Notices />;

      case "Gallery":
        return <Gallery />;

      case "Polls":
        return <AdminPollsSection />;

      default:
        return <AdminDashboardHome />;
    }
  };

  return (
    <div className="admin-layout">
      <Sidebar
        active={activeSection}
        setActive={setActiveSection}
        isOpen={sidebarOpen}
        closeSidebar={() => setSidebarOpen(false)}
      />

      <div className="admin-main">
        <Topbar onMenuClick={() => setSidebarOpen(true)} />
        <div className="admin-content">{renderSection()}</div>
      </div>
    </div>
  );
};

export default AdminDashboard;
